import { useLocation, useNavigate } from "react-router-dom";
import MultiPane from "@components/tabs-responsive/tabs-responsive";
import MessagesList from "./messages-list";
import MessagesClients from "./messages-clients";
import MessagesTokens from "./messages-tokens";
import MessageDialogs from "./message-dialogs";
import "./messages.css";

const Messages = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const items = [
    {
      key: "/messages",
      label: "Сообщения",
      children: <MessagesList />,
    },
    {
      key: "/messages/dialogs",
      label: "Диалоги",
      children: <MessageDialogs />,
    },
    {
      key: "/messages/clients",
      label: "Клиенты",
      children: <MessagesClients />,
    },
    {
      key: "/messages/tokens",
      label: "Каналы",
      children: <MessagesTokens />,
    },
  ];

  const activeKey = items.find(item => location.pathname === item.key)?.key || items[0].key;

  const onTabChange = (key) => {
    navigate(key);
  };

  return (
    <div className="page">
      <MultiPane
        activeKey={activeKey}
        items={items}
        onChange={onTabChange}
        type="card"
      />
    </div>
  );
};

export default Messages;

